// src/pages/LedgerUserPage.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function LedgerUserPage() {
  const { user } = useAuth();
  const [relations, setRelations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const pharmacyCode = String(user?.pharmacyCode || "");

  useEffect(() => {
    if (!pharmacyCode) {
      setError("Nepodařilo se načíst údaje o pobočce.");
      setLoading(false);
      return;
    }

    async function fetchLedger() {
      try {
        const res = await fetch(
          `/api/ledger?firma=LEMON&pharmacyCode=${pharmacyCode}`,
          { method: "GET", credentials: "include" }
        );

        if (!res.ok) throw new Error("Chyba při načítání ledgeru");

        const json = await res.json();
        const raw = Array.isArray(json?.relations) ? json.relations : [];

        // Normalizace partnera – vždy ukazujeme protistranu
        const normalized = raw.map((r) => {
          const from = String(r.fromPharmacy ?? "");
          const to = String(r.toPharmacy ?? "");
          const partner = from === pharmacyCode ? to : from;
          return {
            partner,
            saldo: Number(r.saldo ?? 0),
          };
        });

        setRelations(normalized);
      } catch (err) {
        console.error("❌ Chyba při načítání ledgeru:", err);
        setError("Nepodařilo se načíst data účetní kniha.");
      } finally {
        setLoading(false);
      }
    }

    fetchLedger();
  }, [pharmacyCode]);

  const formatCurrency = (value) =>
    Number(value || 0)
      .toLocaleString("cs-CZ", {
        style: "currency",
        currency: "CZK",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      .replace(/\. /g, ".");

  if (loading) return <div className="p-4 text-gray-600">Načítám data...</div>;
  if (error) return <div className="p-4 text-red-600">{error}</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-6">
        Účetní kniha – pobočka {pharmacyCode}
      </h1>

      {relations.length > 0 ? (
        <table className="min-w-full border-collapse bg-white shadow rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 text-left font-medium text-gray-700">
                Pobočka
              </th>
              <th className="py-3 px-4 text-right font-medium text-gray-700">
                Celkové saldo
              </th>
            </tr>
          </thead>

          <tbody>
            {relations.map((r) => (
              <tr key={r.partner} className="border-t hover:bg-gray-50">
                <td className="py-3 px-4">{r.partner}</td>

                <td
                  className={`py-3 px-4 text-right font-medium ${
                    r.saldo > 0
                      ? "text-green-600"
                      : r.saldo < 0
                      ? "text-red-600"
                      : "text-gray-500"
                  }`}
                >
                  {formatCurrency(r.saldo)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-gray-500">Žádné záznamy v účetní knize.</div>
      )}
    </div>
  );
}
